import React from 'react';
import { Box, Divider, makeStyles } from '@material-ui/core';
import EditMultiCountdown from 'src/components/editor/EditMultiCountdown';
import EditCountdown from 'src/components/editor/EditCountdown';
import EditMultiText from 'src/components/editor/EditMultiText';
import EditText from 'src/components/editor/EditTextRegurcy';
import EditBgImage from 'src/components/editor/EditBgImageRegurcy';
import EditMultiBgImage from 'src/components/editor/EditMultiBgImage';
import EditRadius from 'src/components/editor/EditRadiusRegurcy';
import EditDeeplink from 'src/components/editor/EditDeeplinkRegurcy';
import EditMultiDeeplink from 'src/components/editor/EditMultiDeeplink';
import EditBg from 'src/components/editor/EditBgRegurcy';
import EditMultiBg from 'src/components/editor/EditMultiBg';
import EditBgVideo from 'src/components/editor/EditBgVideo';
import EditRouletteItems from 'src/components/editor/EditRouletteItems';
import EditBgColor from 'src/components/editor/EditBgColorRegurcy/EditBgColor';
import { useSelector, RootState } from 'src/store';

const useStyles = makeStyles({
  divider: {
    height: '1px',
    backgroundColor: '#E5E8EB',
    margin: '0 16px'
  }
});

const Text: any = ({ datas }: any) => {
  const classes = useStyles();
  const btnType = useSelector((state: RootState) => state.buttons.btnType);
  const switchImageType = useSelector(
    (state: RootState) => state.switchButton.switchImageType
  );

  if (datas?.convert && btnType === 'single') {
    datas.deeplinkType = ['image_button'];
  } else if (datas?.convert && btnType === 'double') {
    datas.deeplinkType = ['image_left_button', 'image_right_button'];
  }

  if (datas?.switchImageType && switchImageType === 'double') {
    datas.imageType = ['top_image', 'bottom_image'];
    datas.deeplinkType = ['top_image', 'bottom_image'];
  } else if (datas?.switchImageType && switchImageType === 'quard') {
    datas.imageType = [
      'top_left_image',
      'top_right_image',
      'bottom_left_image',
      'bottom_right_image'
    ];
    datas.deeplinkType = [
      'top_left_image',
      'top_right_image',
      'bottom_left_image',
      'bottom_right_image'
    ];
  }

  return (
    <Box>
      {datas?.bgType?.map((type: any, idx: number) => (
        <div key={idx}>
          <EditBg
            menuTitle={type
              .split('_')
              .join(' ')
              .toUpperCase()}
            type={type}
          />
          {datas?.radiusType && datas?.radiusType?.indexOf(type) !== -1 && (
            <EditRadius
              menuTitle={type
                .split('_')
                .join(' ')
                .toUpperCase()}
              type={type}
              max={datas?.radiusMax?.[datas?.radiusType?.indexOf(type)]}
            />
          )}
          <Divider className={classes.divider} />
        </div>
      ))}

      {datas?.multiBgType?.map((type: any, idx: number) => (
        <div key={idx}>
          <EditMultiBg
            menuTitle={type
              .split('_')
              .join(' ')
              .toUpperCase()
              .replace('MULTI ', '')}
            type={type}
          />
          {datas?.radiusType && datas?.radiusType?.indexOf(type) !== -1 && (
            <EditRadius
              menuTitle={type
                .split('_')
                .join(' ')
                .toUpperCase()
                .replace('MULTI ', '')}
              type={type}
              max={datas?.radiusMax?.[datas?.radiusType?.indexOf(type)]}
            />
          )}
          <Divider className={classes.divider} />
        </div>
      ))}
      {datas?.videoType?.map((type: any, idx: number) => (
        <div key={idx}>
          <EditBgVideo menuTitle="VIDEO LINK" type={type} />
        </div>
      ))}
      {datas?.bgColorType?.map((type: any, idx: number) => (
        <div key={idx}>
          <EditBgColor
            menuTitle={type
              .split('_')
              .join(' ')
              .toUpperCase()}
            type={type}
          />
          {datas?.radiusType && datas?.radiusType?.indexOf(type) !== -1 && (
            <EditRadius
              menuTitle={type
                .split('_')
                .join(' ')
                .toUpperCase()}
              type={type}
              max={datas?.radiusMax?.[datas?.radiusType?.indexOf(type)]}
            />
          )}
          <Divider className={classes.divider} />
        </div>
      ))}
      {datas?.imageType?.map((type: any, idx: number) => (
        <div key={idx}>
          <EditBgImage
            menuTitle={
              type === 'background'
                ? 'IMAGE LINK'
                : `${type
                    .split('_')
                    .join(' ')
                    .toUpperCase()} LINK`
            }
            type={type}
          />
          {datas?.radiusType && datas?.radiusType?.indexOf(type) !== -1 && (
            <EditRadius
              menuTitle={
                type === 'background'
                  ? 'IMAGE'
                  : `${type
                      .split('_')
                      .join(' ')
                      .toUpperCase()} RADIUS`
              }
              type={type}
              max={datas?.radiusMax?.[datas?.radiusType?.indexOf(type)]}
            />
          )}
          <Divider className={classes.divider} />
        </div>
      ))}

      {datas?.multiImageType?.map((type: any, idx: number) => (
        <div key={idx}>
          <EditMultiBgImage menuTitle="IMAGE LINK" type={type} />
          {datas?.radiusType && datas?.radiusType?.indexOf(type) !== -1 && (
            <EditRadius
              menuTitle="IMAGE"
              type={type}
              max={datas?.radiusMax?.[datas?.radiusType?.indexOf(type)]}
            />
          )}
          <Divider className={classes.divider} />
        </div>
      ))}

      {datas?.deeplinkType?.map((type: any, idx: number) => (
        <div key={idx}>
          <EditDeeplink
            menuTitle={type
              .split('_')
              .join(' ')
              .toUpperCase()}
            type={type}
          />
          <Divider className={classes.divider} />
        </div>
      ))}

      {datas?.multiDeeplinkType?.map((type: any, idx: number) => (
        <div key={idx}>
          <EditMultiDeeplink
            menuTitle={type
              .split('_')
              .join(' ')
              .toUpperCase()}
            type={type}
          />
          <Divider className={classes.divider} />
        </div>
      ))}

      {datas?.textType?.map((type: any, idx: number) => (
        <div key={idx} style={{ position: 'relative' }}>
          {type === 'roulette_items' ? (
            <EditRouletteItems menuTitle="ROULETTE ITEMS" type={type} />
          ) : (
            <EditText
              menuTitle={type
                .split('_')
                .join(' ')
                .toUpperCase()}
              type={type}
            />
          )}

          <Divider className={classes.divider} />
        </div>
      ))}

      {datas?.multiTextType?.map((type: any, idx: number) => (
        <div key={idx} style={{ position: 'relative' }}>
          <EditMultiText
            menuTitle={type
              .split('_')
              .join(' ')
              .toUpperCase()
              .replace('MULTI ', '')}
            type={type}
          />

          <Divider className={classes.divider} />
        </div>
      ))}
      {datas?.countdownType?.map((type: any, idx: number) => (
        <div key={idx}>
          <EditCountdown
            menuTitle={type
              .split('_')
              .join(' ')
              .toUpperCase()}
            type={type}
          />
          <Divider className={classes.divider} />
        </div>
      ))}
      {datas?.multiCountdownType?.map((type: any, idx: number) => (
        <div key={idx}>
          <EditMultiCountdown
            menuTitle={type
              .split('_')
              .join(' ')
              .toUpperCase()
              .replace('MULTI ', '')}
            type={type}
          />
          <Divider className={classes.divider} />
        </div>
      ))}
    </Box>
  );
};

export default Text;
